const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/hooks/useScrollToAddedElement.ts';
import { useEffect } from 'react';
import _ from 'lodash';

type Selectors = {
    element: string;
    root?: string;
};

// Please note that the arguments should not be variable and should not change run time
export const useScrollToAddedElement = (selectors: Selectors, options: ScrollIntoViewOptions = {}) => {
    const scrollIntoViewOptions: ScrollIntoViewOptions = { behavior: 'smooth', block: 'center', ...options };

    const elementSelector = selectors.element;
    const rootSelector = selectors.root;

    const selector = _.compact([rootSelector, elementSelector]).join(' ');
    const scrollToNode = () => {
        document.querySelector(selector)?.scrollIntoView(scrollIntoViewOptions);
    };

    useEffect(() => {
        const mutationCallback = (mutationList: [MutationRecord]) => {
            const filter = mutationList.filter((part: MutationRecord) => {
                if (part.type === 'childList') {
                    return (part.target as HTMLElement).querySelector(elementSelector);
                }
            });

            if (filter.length !== 0) {
                scrollToNode();
            }
        };

        const config = { childList: true, subtree: true };
        const mutationObserver = new MutationObserver(mutationCallback);
        const rootNode = rootSelector ? document.querySelector(rootSelector) : document.body;
        if (rootNode) {
            mutationObserver.observe(rootNode, config);
        } else {
            throw 'Queried root is not found';
        }
        return () => {
            mutationObserver.disconnect();
        };
    }, []);

    return [scrollToNode];
};